export const getFieldLabel = () => {
  const domain = window.location.hostname;
  switch (domain) {
    case "ep.maot.co.kr":
      return "작업장명";
    case "nhsafe.maot.co.kr":
      return "현장명";
    case "jnedu.maot.co.kr":
      return "학교(기관)명";
    default:
      return "학교(기관)명";
    // return "사업장명";
  }
};
export const type442 = () => {
  const domain = window.location.hostname;
  switch (domain) {
    case "jnedu.maot.co.kr":
      return "학교(기관)별";
    default:
      return "학교(기관)별";
    // return "사업장별";
  }
};
